/*==================================================
WG BLOG
==================================================*/

document.addEventListener('DOMContentLoaded', () => {

const cards = document.querySelectorAll(
'.wg-blog-featured, .wg-blog-card'
);

if(!cards.length) return;

const observer = new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add('is-visible');

observer.unobserve(entry.target);

}

});

},{
threshold:.15
});

cards.forEach(card=>observer.observe(card));

});